import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const RealEstate  = () => {

  const  servicesFaqData = [
    { 
        question: "What is real estate printing, and what materials are included?   ", 
        answer: "Real estate printing involves creating high-quality marketing materials to showcase properties and services, such as brochures, flyers, business cards, and signage. It includes real estate brochure printing to provide potential buyers with detailed property information. Custom signage and banners are also used to attract attention to listings or open houses. These materials are essential for effective marketing, helping real estate agents and developers connect with clients and stand out in a competitive market."
    },
    { 
        question: "What are the benefits of custom real estate brochure printing?    ", 
        answer: "Real estate brochure printing allows you to create visually engaging materials highlighting property details, features, and benefits. Customisation ensures that brochures reflect your brand identity and meet the needs of your target audience. High-quality materials and vibrant printing enhance the professional appearance of your brochures, making them more impactful. Brochures also serve as a tangible resource for clients, providing detailed information to support decision-making. This combination of aesthetics and functionality makes custom brochures invaluable in real estate marketing."
    },
    { 
        question: "Can Printingy handle bulk orders for real estate printing services?    ", 
        answer: "Yes, Printingy specialises in bulk real estate printing services, providing cost-effective solutions for large-scale marketing campaigns. Bulk printing ensures consistent quality across all materials and reduces per-unit costs, making it ideal for agencies and developers with multiple properties. Advanced printing technology guarantees precision and durability for every order, regardless of size. We also offer quick turnaround times, ensuring your marketing materials are ready for distribution on schedule. Printingy’s reliable bulk printing services help streamline your marketing efforts and enhance your brand visibility."
    },
    { 
        question: "What materials are used for printing solutions for real estate?   ", 
        answer: "Our real estate printing solutions use premium materials such as high-gloss paper, textured cardstock, and weather-resistant signage. High-gloss paper is ideal for brochures and flyers, providing vibrant colours and sharp details. Textured cardstock adds a sophisticated touch to business cards and high-end marketing materials. Weather-resistant signage is perfect for outdoor use, ensuring durability and longevity in various conditions. These materials are carefully chosen to meet the unique requirements of the real estate industry, providing a professional and impactful presentation."
    },
    { 
        question: "What industries and individuals benefit from real estate printing services?  ", 
        answer: "Real estate printing services benefit real estate agents, developers, and marketing teams significantly. Agents use brochures, flyers, and signage to showcase properties and attract potential buyers. Developers rely on printed materials to promote new projects and communicate with stakeholders. Marketing teams utilise custom printing solutions for branding, client communication, and promotional campaigns. These services provide the tools to effectively market properties, build client trust, and enhance the overall real estate experience."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing for Real Estate');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title=" Professional Real Estate Printing Services"
  description="High-quality printing for real estate brochures, marketing materials, and custom designs. Bulk real estate printing services and tailored printing solutions for real estate."
  keywords="Printing for Real Estate,
Real Estate Printing,
Real Estate Printing Services,
Real Estate Brochure Printing,
Printing Solutions for Real Estate



"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing for Real Estate </h1>
              <h2 className="text-muted">Customised printing solutions for real estate marketing and branding </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>In real estate, impactful marketing materials are essential for showcasing properties and building client trust. Printingy specialises in Printing for Real Estate, delivering high-quality real estate printing services tailored to meet industry needs.</p>
          <p>Our offerings include real estate brochure printing, and producing visually appealing and informative brochures highlighting property features. We also provide comprehensive real estate printing solutions, covering flyers, signage, business cards, and promotional materials. With advanced technology and premium materials, Printingy ensures professional results that enhance your brand and sales efforts.</p>
          
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Real Estate Printing Solutions </h2>
                <h3 className="large-hed">High-quality, impactful marketing materials for property listings and branding   </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing for Real Estate with tailored designs for property marketing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk real estate printing services with competitive pricing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional real estate brochure printing for showcasing properties.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Comprehensive printing solutions for real estate, including signage and promotional materials.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable and vibrant materials for a professional appearance.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-resolution visuals to highlight property details and branding.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for real estate agents, developers, and marketing teams.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/realestateprinting.jpg" // Path relative to the public folder
                  alt="Professional printing for real estate marketing materials"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Real Estate Printing Delivered On Time </h2>
            <h3 className="small-hed">Focus on selling properties while we manage your printing needs  </h3>
            <p>At Printingy, we combine advanced technology with premium materials to deliver exceptional real estate printing services. Whether for brochures, signage, or marketing materials, our solutions ensure visually appealing and durable results that elevate your property listings.
            </p>
            <p>We prioritise efficiency and quality, guaranteeing timely delivery for all bulk and customised orders. Partner with Printingy for reliable and professional printing solutions tailored for real estate success.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default RealEstate;
